<template>
  <div class="aftersale-shippingList print-font">
    <div class="main">
      <div class="print-font">
        <div class="title">售后发货清单</div>
        <el-form :inline="true" :model="shippingForm" label-position="left">
          <el-form-item label="服务编号:">{{shippingForm.main_number}}</el-form-item>
          <el-form-item label="发货日期:">{{shippingForm.date}}</el-form-item>
          <div>
            <el-form-item label="收货方:">{{shippingForm.user_name}}</el-form-item>
          </div>
        </el-form>
        <el-table :data="shippingTableData" border style="width: 100%">
          <el-table-column type="index" label="序号">
          </el-table-column>
          <el-table-column prop="sku" label="商品编码">
          </el-table-column>
          <el-table-column prop="name" label="商品名称">
          </el-table-column>
          <el-table-column prop="unit" label="单位">
          </el-table-column>
          <el-table-column prop="returned_num" label="数量">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="btn">
      <el-button type="primary" size="small" @click="myPrint">打印</el-button>
    </div>
  </div>
</template>
<script>
import { bigshippingList } from '@/models/aftersaleModel'
export default {
  data () {
    return {
      shippingForm: {
        address: '',
        box_num: '',
        date: '',
        mobile: '',
        main_number: '',
        user_name: '',
        weight: ''
      },
      shippingTableData: []
    }
  },
  mounted () {
    this.initAftersaleData()
  },
  methods: {
    async initAftersaleData () {
      let params = {
        as_id: this.$route.params.as_id,
        order_type: 1
      }
      let data = await bigshippingList(params)
      this.shippingForm = data
      this.shippingTableData = new Array(data.item)
    },
    myPrint () {
      let subOutputRankPrint = document.querySelector('.main')
      let newContent = subOutputRankPrint.innerHTML
      let oldContent = document.body.innerHTML
      document.body.innerHTML = newContent
      window.print()
      window.location.reload()
      document.body.innerHTML = oldContent
      return false
    }
  }
}
</script>
<style lang="scss">
.aftersale-shippingList {
  padding: 10px;
  .main {
    border:1px solid grey;
    padding: 10px;
    .el-form .el-form-item__label {
      width: auto;
    }
    .el-form-item__content {
      font-size: 12px;
    }
    .title {
    text-align: center;
    font-weight: bold;
    }
    .el-form {
      border-bottom: 1px dashed grey;
      padding-bottom: 10px;
    }
    .el-table {
      margin-top: 20px;
    }
    .warning-info {
      font-size: 12px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .btn {
    margin-top: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bigAftersale/aftersale-shipping-list.vue